import React from 'react'
import { Switch, Route, Redirect, Link, useLocation } from 'react-router-dom'
import { FadeIn, FlexWrapper } from 'lib/ui'
import { Title } from '../../components/Styled'
import { CommerceHubAdd } from './scenes/CommerceHubAdd'
import { PaymentHome } from './scenes/PaymentHome'

export const Payment = () => {
  const location = useLocation()
  const isHome = location.pathname === '/customer/account/payment'

  return (
    <FadeIn>
      <FlexWrapper className='flex-title'>
        <Title>
          Payment Methods
        </Title>
        <Link to={isHome ? '/customer/account' : '/customer/account/payment'}>Back</Link>
      </FlexWrapper>
      <div style={{ minHeight: 400, padding: '0 0 40px' }}>
        <Switch>
          <Route exact path='/customer/account/payment' component={PaymentHome} />
          <Route exact path='/customer/account/payment/commercehub/add' component={CommerceHubAdd} />
          <Redirect to='/customer/account/payment' />
        </Switch>
      </div>
    </FadeIn>
  )
}
